import {currentCartV2} from '@wix/ecom';

export class CartModel {
  public id?: string;
  public itemsCount?: number;

  constructor(params: CartModel) {
    this.id = params.id;
    this.itemsCount = params.itemsCount;
  }

  public static fromCartV2(cart: currentCartV2.Cart): CartModel {
    return new CartModel({
      id: cart._id!,
      itemsCount: calculateItemsCount(cart.lineItems),
    });
  }
}

function calculateItemsCount(items?: Partial<currentCartV2.V2LineItem>[]): number | undefined {
  return items?.reduce((count, lineItem) => {
    const {quantityInfo} = lineItem;
    return count + (quantityInfo?.confirmedQuantity || 0);
  }, 0);
}
